module.exports = __webpack_public_path__ + "img/toko-grey.53ffc1b5.png";